import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        messages: []
    },
    mutations: {
        addMessage(state, message) {
            if (!state.messages.includes(message)) {
                state.messages.push(message);
            }
        }
    }
});

Vue.use(VuexI18n.plugin, store)

export default store
